module.exports = __webpack_public_path__ + "static/media/aslGrid2-01.2dada265.jpg";